// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 兼容ie11
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill();
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
import App from './App';
import 'animate.css'

// import 'babel-runtime/core-js/promise'
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 公共样式
import './assets/css/xunyou.css'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;
// Vue.prototype.$payUrl = 'https://wyhx.vanyanghui.com/bingoPay'
Vue.config.productionTip = false;
//图片地址
Vue.prototype.$imageUrl = 'https://zhengtaiproductfile.oss-cn-hangzhou.aliyuncs.com';
Vue.prototype.$imageUrlNew = 'https://backupfie.empowerchint.com';
//绑定环境地址
import {baseUrl} from './api/axiosFun'
Vue.prototype.$baseUrl = baseUrl;

window.localStorage.setItem('baseUrl',Vue.prototype.$baseUrl)
//微信快捷登录
// Vue.prototype.$wxbBaseUrl = 'http://www.chintyy.com/';
Vue.prototype.$wxbBaseUrl = 'https://www.empowerchint.com/';

// 使用element UI
Vue.use(ElementUI);
//地图定位组件

import VueAMap from 'vue-amap';
Vue.use(VueAMap);

VueAMap.initAMapApiLoader({

    key: 'ebd1337d8177f94f8515451a9023f23d',
    plugin: [
        'AMap.Autocomplete',
        'AMap.PlaceSearch',
        'AMap.Scale',
        'AMap.OverView',
        'AMap.ToolBar',
        'AMap.MapType',
        'AMap.PolyEditor',
        'AMap.CircleEditor',
        'AMap.Geolocation'
    ],
    // 默认高德 sdk 版本为 1.4.4
    v: '1.4.4'
});
// 过滤器
import * as custom from './utils/util'

// 引入layui
// import layui from './assets/layui/layui'
// // import './assets/layui/css/modules/layer/default'
// Vue.prototype.$layui = layui

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 路由拦截器
// router.beforeEach((to, from, next) => {
//     if (to.matched.length != 0) {
//         if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
//             if (Boolean(localStorage.getItem("userdata"))) { // 通过vuex state获取当前的user是否存在
//                 if(document.cookie.indexOf("userdata=")!=-1){
//                     if(to.fullPath=="/tender"){ //判断用户是否是企业用户
//                         // if(JSON.parse(localStorage.getItem("userType"))!=2){
//                         //     ElementUI.Message({
//                         //         message: '企业用户才能查看'
//                         //     })
//                         //     next('/')
//                         // }else{
//                         //     next()
//                         // }
//                         if(JSON.parse(localStorage.getItem("userType"))==1){
//                             ElementUI.Message({
//                                 message: '企业用户才能查看,请升级企业账号'
//                             })
//                             next('/Guidance')
//                         } else if(JSON.parse(localStorage.getItem("userType"))==3){
//                             ElementUI.Message({
//                                 message: '电工用户不可查看'
//                             })
//                             next()
//                         }else{
//                             next()
//                         }
//                     }else{
//                         next();
//                     }
//                 }else {
//                     localStorage.removeItem('userdata')
//                     ElementUI.Message({
//                         message: '登录账户超时,请重新登录'
//                     })
//                     next('/login');
//                 }


//             } else {
//                 next({
//                     path: '/login',
//                     query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
//                 })
//             }
//         } else {
//             next();
//             //     if (Boolean(localStorage.getItem("userdata"))) { // 判断是否登录
//             //         if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
//             //             next();
//             //         } else {
//             //             /**
//             //              * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
//             //              */
//             //             next({
//             //                 path: '/dashboard/main'
//             //             })
//             //         }
//             //     } else {
//             //         next();
//             //     }
//         }
//     } else {
//         next({
//             path: '/login',
//             query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
//         })
//     }
// })
require('es6-promise').polyfill()
    // 禁止在控制台打印
    // console.log = function(){}
    //  alert = function(){}

/* eslint-disable no-new */
const jumpUrl = function (paths,id) {
    let routeData = router.resolve({
      path: paths,
      query: { id: id }
    });
    // console.log(routeData)
    window.open(routeData.href, '_blank');
  }
  Vue.prototype.$jumpUrl = jumpUrl
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})



// WEBPACK FOOTER //
// ./src/main.js